import { render, staticRenderFns } from "./appUsers.vue?vue&type=template&id=5b83d1a8&scoped=true"
import script from "./appUsers.vue?vue&type=script&lang=js"
export * from "./appUsers.vue?vue&type=script&lang=js"
import style0 from "./appUsers.vue?vue&type=style&index=0&id=5b83d1a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b83d1a8",
  null
  
)

export default component.exports